"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tooltipContainerId = exports.toastContainerId = exports.portalRootId = exports.modalContainerId = exports.alertContainerId = exports.PortalProvider = exports.PortalHost = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _PortalContext = require("@cbhq/cds-common/overlays/PortalContext");
var _ToastProvider = require("@cbhq/cds-common/overlays/ToastProvider");
var _usePortalState = require("@cbhq/cds-common/overlays/usePortalState");
var _zIndex = require("@cbhq/cds-common/tokens/zIndex");
var _Hexagon = require("../media/Hexagon");
var _BrowserOnly = require("../system/BrowserOnly");
var _browser = require("../utils/browser");
var _getBrowserGlobals;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const portalRootId = 'portalRoot';
exports.portalRootId = portalRootId;
const modalContainerId = 'modalsContainer';
exports.modalContainerId = modalContainerId;
const alertContainerId = 'alertsContainer';
exports.alertContainerId = alertContainerId;
const toastContainerId = 'toastsContainer';
exports.toastContainerId = toastContainerId;
const tooltipContainerId = 'tooltipContainer';
exports.tooltipContainerId = tooltipContainerId;
const safeDocument = (_getBrowserGlobals = (0, _browser.getBrowserGlobals)()) === null || _getBrowserGlobals === void 0 ? void 0 : _getBrowserGlobals.document;
const PortalHost = /*#__PURE__*/(0, _react.memo)(() => {
  const portalRoot = (0, _react.useMemo)(
  // prevent duplicate portal root
  () => safeDocument === null || safeDocument === void 0 ? void 0 : safeDocument.createElement('div'), []);
  (0, _react.useEffect)(() => {
    const target = safeDocument === null || safeDocument === void 0 ? void 0 : safeDocument.body;

    // prevent duplicate host
    if (safeDocument !== null && safeDocument !== void 0 && safeDocument.getElementById(portalRootId) || !portalRoot) return undefined;
    portalRoot.id = portalRootId;
    portalRoot.style.zIndex = String(_zIndex.zIndex.overlays.portal);
    // enable stack order
    portalRoot.style.position = 'relative';
    // enable stack order on children
    portalRoot.style.display = 'flex';

    // Append element to dom
    target === null || target === void 0 ? void 0 : target.appendChild(portalRoot);

    // Avoid removing child from other provider
    // This happens when multiple PortalProvider are defined
    return () => {
      // Remove element from dom
      target === null || target === void 0 ? void 0 : target.removeChild(portalRoot);
    };
  }, [portalRoot]);
  if (!portalRoot) return null;
  return /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "portal-modal-container",
    id: modalContainerId,
    style: {
      zIndex: _zIndex.zIndex.overlays.modal
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "portal-toast-container",
    id: toastContainerId,
    style: {
      zIndex: _zIndex.zIndex.overlays.toast
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "portal-alert-container",
    id: alertContainerId,
    style: {
      zIndex: _zIndex.zIndex.overlays.alert
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "portal-tooltip-container",
    id: tooltipContainerId,
    style: {
      zIndex: _zIndex.zIndex.overlays.tooltip
    }
  })), portalRoot);
});
exports.PortalHost = PortalHost;
const PortalProvider = /*#__PURE__*/(0, _react.memo)(({
  children,
  toastBottomOffset = 0
}) => {
  const portalState = (0, _usePortalState.usePortalState)();
  return /*#__PURE__*/_react.default.createElement(_PortalContext.PortalContext.Provider, {
    value: portalState
  }, /*#__PURE__*/_react.default.createElement(_ToastProvider.ToastProvider, {
    toastBottomOffset: toastBottomOffset
  }, /*#__PURE__*/_react.default.createElement(_BrowserOnly.BrowserOnly, null, /*#__PURE__*/_react.default.createElement(PortalHost, null)), portalState.nodes.map(node => node.element), children, /*#__PURE__*/_react.default.createElement(_Hexagon.IsoHexagonClipPath, null)));
});
exports.PortalProvider = PortalProvider;